export default __webpack_public_path__ + "static/media/image02.013220fc.jpg";